import { BookOpen, ExternalLink, Calendar, User } from 'lucide-react';

export default function Publications({ publications }) {
  return (
    <section id="publications" className="bg-white rounded-2xl shadow-card overflow-hidden">
      <div className="px-6 py-4 border-b flex items-center justify-between" style={{ background: '#021f30' }}>
        <div className="flex items-center gap-2">
          <BookOpen size={16} className="text-white/70" />
          <h3 className="text-white font-bold text-base">Publications</h3>
        </div>
        <span className="text-white/50 text-xs">{publications.length} references</span>
      </div>

      <div className="p-6 flex flex-col gap-4">
        {publications.map((pub, i) => (
          <div
            key={pub.pmid}
            className="p-4 rounded-xl border border-gray-200 hover:border-gray-300 transition-all card-hover"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-start gap-2">
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white mt-0.5"
                    style={{ background: '#021f30' }}>
                    {i + 1}
                  </span>
                  <h4 className="font-semibold text-gray-900 text-sm leading-snug">{pub.title}</h4>
                </div>

                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2.5 pl-8">
                  <div className="flex items-center gap-1.5 text-xs text-gray-500">
                    <User size={12} />
                    <span>{pub.authors}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs">
                    <span className="italic font-semibold" style={{ color: '#f93441' }}>{pub.journal}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-gray-500">
                    <Calendar size={12} />
                    <span>{pub.year}</span>
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-2 mt-2.5 pl-8">
                  <span className="px-2 py-0.5 rounded-md text-xs font-mono bg-blue-50 text-blue-700 border border-blue-100">
                    PMID: {pub.pmid}
                  </span>
                  <span className="px-2 py-0.5 rounded-md text-xs font-mono bg-gray-50 text-gray-600 border border-gray-200 truncate max-w-[220px]">
                    DOI: {pub.doi}
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-2 shrink-0">
                <a
                  href={`https://pubmed.ncbi.nlm.nih.gov/${pub.pmid}/`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold text-white transition-all hover:brightness-110 whitespace-nowrap"
                  style={{ background: '#021f30' }}
                >
                  View on PubMed
                  <ExternalLink size={11} />
                </a>
                <a
                  href={`https://doi.org/${pub.doi}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold border border-gray-200 text-gray-600 hover:bg-gray-50 transition-all whitespace-nowrap"
                >
                  DOI Link
                  <ExternalLink size={11} />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
